import { faMoon } from '@fortawesome/pro-light-svg-icons/faMoon'
import Switch from '@space-core/components/switch/user'
import useTranslation from '@space-core/hooks/useTranslation'
import CustomLanguage from '@space-shell/common/components/customLanguage'
import type { ApplicationLanguageType } from '@space-shell/common/components/customLanguage/constants'
import { useMembershipStore } from '@space-shell/core/store'
import RankingCard from '@space-shell/modules/gamification/components/rankingCard'

type HeaderOptionsProps = {
  isGamificationEnabled: boolean
  isAuthenticated: boolean
  switchTheme: () => void
  applicationLanguage: string
  handleLanguageChange: (lang: ApplicationLanguageType) => void
  theme: string
}

export default function HeaderOptions({
  isGamificationEnabled,
  isAuthenticated,
  switchTheme,
  applicationLanguage,
  handleLanguageChange,
  theme
}: HeaderOptionsProps) {
  const { t } = useTranslation()
  const { membershipData } = useMembershipStore()

  return (
    <>
      {isGamificationEnabled && isAuthenticated && <RankingCard />}
      {membershipData?.settings.allowChangeTheme && (
        <Switch
          handleClick={switchTheme}
          label={t('general.theme.dark')}
          theme={theme}
          icon={faMoon}
        />
      )}
      <CustomLanguage
        applicationLanguage={applicationLanguage as ApplicationLanguageType}
        handleClickLanguageOption={handleLanguageChange}
        labelCustomLanguage={t('general.language')}
      />
    </>
  )
}
